import { createFiltersSlice } from '../../../store/createFiltersSlice'

// Panel filters that sit behind the "Apply" button. NOTE: `status` (stage tab) is NOT
// here — it is an immediate control handled by its own `setStatus` action.
const initialFilters = {
    search: '', result: '', lastVisited: '',
    excludeProdDemo: null, startDate: '', endDate: '',
    // Client-document filters (tri-state: '' = any, 'provided', 'not_provided').
    clientDocuments: '', clientPhotoId: '',
}

const preChecksFiltersSlice = createFiltersSlice({
    name: 'preChecksFilters',
    initialFilters,
})

export const {
    setDraftFilter, setDraftRequestorIds, setDraftLatestQaActionBy, setDraftFraudTypes, setDraftCompanyId,
    applyFilters, resetDraft, applyDefaultRequestor, clearFilters,
    setStatus, setSortConfig, setCurrentPage, setItemsPerPage,
} = preChecksFiltersSlice.actions

export default preChecksFiltersSlice.reducer
